import { IApplicationState } from '../../types/redux';
import { selectOffer } from './selectOffer';
import { getFirstImageFromOffer } from '../../utils/offerImage';

export const selectOfferFirstImage = (id: number) => (state: IApplicationState) => {
  const offer = selectOffer(id)(state);

  return getFirstImageFromOffer(offer);
};
